import $ from 'jquery' // jQuery
import flatpickr from 'flatpickr' // flatpickr
import 'flatpickr/dist/l10n/ja' // flatpickr日本語化
import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉
import scrollLock from './functions/_scrollLock.js' // スクロールロック

import './module/_datePicker.js' // 日付入力

/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
import './_edit.js'
import './_publish.js'
import './_form.js'
import './_sp.js'
import './_store.js'
import './_ajax.js'
import './_password.js'
import './_contact.js'
import './_wysiwyg.js'
import './_deviceSwap.js'
import './_fileSend.js'
import './_expand.js'
import './_pdfUpload.js'
import './_storeRecruit.js'
import './_reservationTable.js'
import './_checkConf.js'
import './_formExit.js'
import './_copyArea.js'
import './_popAlert.js'
import './_validation.js'
import './_graph.js'

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

document.addEventListener('DOMContentLoaded', function () {
  // タブに対してクリックイベントを適用
  const tabs = document.getElementsByClassName('tab')
  for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', tabSwitch, false)
  }
  // タブをクリックすると実行する関数
  function tabSwitch() {
    // タブのclassの値を変更
    $('.tab').removeClass('is-active')
    this.classList.toggle('is-active')
    const arrayTabs = Array.prototype.slice.call(tabs)
    const index = arrayTabs.indexOf(this)
    $('.panel').removeClass('is-show')
    document.getElementsByClassName('panel')[index].classList.toggle('is-show')
  }
})
window.changeSetup = function () {
  $('input[name=color]').on('change', function () {
    $('.item').removeClass('checked')
    $('.btn').prop('disabled', true)
    $(this).parents('.item').addClass('checked')
    $(this).parent().siblings().children('.btn').prop('disabled', false)
  })
  $('.js-recruit-type').on('click', function () {
    $('.js-recruit-type').removeClass('current')
    $(this).addClass('current')
  })
  $('.js-img-display').on('change', function () {
    if ($(this).val() === '表示') {
      $(this).parents('.item').addClass('checked')
      $(this).parents('.item').find('.btn').prop('disabled', false)
    } else {
      $(this).parents('.item').removeClass('checked')
      $(this).parents('.item').find('.btn').prop('disabled', true)
    }
  })
}
window.changeSetup() // 入力系のセットアップ

window.selectSetup = function () {
  $('select.custom-select:not(.complete)').each(function () {
    const classes = $(this).attr('class')
    let template = '<div class="' + classes + '">'
    template +=
      '<button type="button" class="custom-select-trigger"><span class="is-false custom-select-trigger-text">' +
      $(this).attr('placeholder') +
      '</span><i class="is-false custom-select-trigger__icon icon-down"></i></button>'
    template += '<div class="custom-options">'
    $(this)
      .find('option')
      .each(function () {
        template +=
          '<span class="custom-option ' +
          $(this).attr('class') +
          '" data-value="' +
          $(this).attr('value') +
          '">' +
          $(this).html() +
          '</span>'
      })
    template += '</div></div>'

    $(this).wrap('<div class="custom-select-wrapper"></div>')
    this.classList.add('complete') // 完了フラグを立てる
    $(this).after(template)

    const selectBase = $(this).parents('.custom-select-wrapper')

    // 開閉処理
    selectBase.find('.custom-select-trigger').on('click', function () {
      $('html').one('click', function () {
        $('.custom-select').removeClass('opened')
      })
      $(this).parents('.custom-select-wrapper').find('.custom-select').toggleClass('opened')
      event.stopPropagation()
    })

    // 選択処理
    selectBase.find('.custom-option').on('click', function () {
      const orgSelect = $(this).parents('.custom-select-wrapper').find('select')

      // 本来のプルダウンを操作
      orgSelect.val($(this).data('value')) // 値を揃える
      orgSelect.trigger('click') // クリックイベントを送る

      window.exitAlert() // 離脱確認を予約する

      $(this).parents('.custom-options').find('.custom-option').removeClass('selection')
      $(this).addClass('selection')
      $(this).parents('.custom-select').removeClass('opened')

      if (orgSelect.val() !== '') {
        $(this).parents('.custom-select').find('.custom-select-trigger-text').text($(this).text())
      } else {
        // 空欄が選ばれたらプレースホルダーを表示
        $(this).parents('.custom-select').find('.custom-select-trigger-text').text(orgSelect.attr('placeholder'))
      }
    })

    // ホバー処理
    selectBase.find('.custom-option:first-of-type').hover(
      function () {
        $(this).parents('.custom-options').addClass('option-hover')
      },
      function () {
        $(this).parents('.custom-options').removeClass('option-hover')
      }
    )
    // マウスアウト処理
    selectBase.find('.custom-options').hover(
      function () {},
      function () {
        $('.custom-select').removeClass('opened')
      }
    )
  })
}

window.selectSetup() // セレクトボックスの初期化

$('.js-side-toggle').on('click', function () {
  $(this).toggleClass('is-active')
  $('.js-side-bar').toggleClass('is-show')
})

$('.js-reservation-edit').on('click', function () {
  $(this).parent().next('.js-reservation-form').toggleClass('is-show')
})

//  ###    ###   #####   ####      ###    ##
//  ## #  # ##  ##   ##  ##  ##   ## ##   ##
//  ##  ##  ##  ##   ##  ##  ##  ##   ##  ##
//  ##      ##  ##   ##  ##  ##  #######  ##
//  ##      ##   #####   ####    ##   ##  ######

const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal

    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }

    modalOverlay.classList.add('active')
    scrollLock('body', '#modalOverlay')
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

window.modalOpen = function (target = '') {
  modalClose()
  const openModals = document.querySelectorAll('.js-modal--' + target)
  for (const openModal of openModals) {
    openModal.classList.add('active')
  }
  modalOverlay.classList.add('active')
  scrollLock('body', '#modalOverlay')
}

const mediaQuery = window.matchMedia('(min-width: 768px)')
function checkWindow(windowSize) {
  let pc
  let sp
  if (windowSize.matches) {
    sp = $('.js-sp').detach()
  } else {
    pc = $('.js-pc').detach()
  }
}
checkWindow(mediaQuery)
mediaQuery.addEventListener('change', checkWindow)

//   ####  ##  ####    #####
//  ##     ##  ##  ##  ##
//   ###   ##  ##  ##  #####
//     ##  ##  ##  ##  ##
//  ####   ##  ####    #####
// サイドバーアコーディオン
window.addEventListener('click', function (e) {
  const item = e.target.closest('.js-side-parent')
  if (!item) {
    return
  }
  item.parentNode.classList.toggle('open')
})

window.datePicker = function () {
  if (!document.querySelector('.js-date')) {
    return
  }

  const datepicker = flatpickr('.js-date', {
    // 指定クラスにデートピッカーを付ける
    // minDate: new Date().fp_incr(1), // 最短設定日 n日後から
    // maxDate: new Date().fp_incr(30), // 最長設定日 n日後まで
    // mode: 'range', // 範囲で指定させる
    locale: 'ja',
    altFormat: 'Y/m/d',
    dateFormat: 'Y/m/d',
    disableMobile: true, // SP時にブラウザ標準の日付UIに切り替えない
    // altFormat: 'Y/m/d H:i',
    // dateFormat: 'Y/m/d H:i',
    // enableTime: true, // 時間指定可能にする
    // time_24hr: false, // 24h/AMPM形式
    disable: [
      // 選択禁止する日付　trueを返すと禁止
      // function (date) {
      //   // 指定番号の曜日と合致したら禁止　0:日曜～6:土曜
      //   if (date.getDay() === 0) {
      //     return true
      //   }
      // },
    ],
    onChange: function (selectedDates, dateStr, instance) {},
  })

  // デフォルトのflatpickrにはクリアボタンが無いのでカレンダー内に増設する
  const datepickerList = document.querySelectorAll('.flatpickr-calendar')
  for (let index = 0; index < datepickerList.length; index++) {
    const element = datepickerList[index]
    const datepickerBtn = document.createElement('button')
    datepickerBtn.innerHTML = '×クリア' // 文言
    datepickerBtn.setAttribute('type', 'button')
    datepickerBtn.setAttribute('style', 'padding: 5px;color: #F67A79')
    datepickerBtn.setAttribute('data-datepicker-clear', index)
    datepickerBtn.addEventListener('click', function (e) {
      if (Array.isArray(datepicker)) {
        datepicker[this.dataset.datepickerClear].clear() // クリア処理
        datepicker[this.dataset.datepickerClear].close() // カレンダーを閉じる
      } else {
        datepicker.clear() // クリア処理
        datepicker.close() // カレンダーを閉じる
      }
    })
    element.appendChild(datepickerBtn)
  }
}

window.addEventListener('pageshow', function () {
  window.datePicker() // デートピッカー起動
})
